export default "__VITE_ASSET__D6G3keaB__"